import { api } from './api'
import { GMSStatus, GMSEligibilityResult, DPSCheckResult, DPSDrug } from '../types/gms'

export const gmsService = {
  /**
   * Check GMS/DVC eligibility by card number (HSE SSPCRS). Optionally pass patientId to store result.
   */
  checkEligibility: async (schemeId: string, patientId?: string): Promise<GMSEligibilityResult> => {
    const response = await api.post<GMSEligibilityResult>('/gms/check-eligibility', {
      schemeId: schemeId.trim(),
      ...(patientId && { patientId }),
    })
    return response.data
  },

  /**
   * Check GMS status for a patient
   */
  checkGMSStatus: async (patientId: string): Promise<GMSStatus> => {
    const response = await api.post<GMSStatus>(`/gms/check-status`, { patientId })
    return response.data
  },

  /**
   * Get GMS status for a patient (cached)
   */
  getGMSStatus: async (patientId: string): Promise<GMSStatus> => {
    const response = await api.get<GMSStatus>(`/gms/status/${patientId}`)
    return response.data
  },

  /**
   * Check if drugs are covered under DPS
   */
  checkDPSDrugs: async (patientId: string, drugCodes: string[]): Promise<DPSCheckResult> => {
    const response = await api.post<DPSCheckResult>(`/gms/check-dps`, {
      patientId,
      drugCodes,
    })
    return response.data
  },

  /**
   * Search for drug information
   */
  searchDrug: async (searchTerm: string): Promise<DPSDrug[]> => {
    const response = await api.get<DPSDrug[]>(`/gms/drugs?search=${encodeURIComponent(searchTerm)}`)
    return response.data
  },
}



































